<aims-common-table
        id="master-report-table"
        [dataSource]="reportScheduleArray"
        [defaultTableState] = "{ sort:{ active : 'reportScheduleNumber', direction: 'asc' }}"
        [addRowInitialObject]="defaultItem"
        [header]="tableHeader"
        [permissions]="tablePermissions"
        [pageSize]="15"
        (rowUpdated)="handleRowUpdate($event)"
        (rowAdded)="handleRowAdded($event)"
        (rowDeleted)="handleRowDelete($event)"
        (rowExpanded)="handleRowExpand($event)"
        [stickyHeader]="true">

  <aims-common-table-dynamic-row id="responsibleManagerId">
    <ng-template viewMode let-element >
      {{ element.responsibleManagerId | getText:'responsibleManagerId':'responsibleManager':responsibleManagerValues | async }}
    </ng-template>

    <ng-template editMode let-element let-dynamicControl="dynamicControl">
      <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
        <mat-select style="width: 100px" [formControl]="dynamicControl" name="responsibleManagerId">
          <mat-option *ngFor="let p of responsibleManagerValues | async" [value]="p.responsibleManagerId">
            {{ p.responsibleManager }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>

    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let p of responsibleManagerValues | async" [value]="p.responsibleManagerId">
            {{ p.responsibleManager }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

  <aims-common-table-dynamic-row id="reportScheduleFrequencyId">
    <ng-template viewMode let-element >
      {{ element.reportScheduleFrequencyId | getText:'reportScheduleFrequencyId':'reportScheduleFrequency':reportFreqValues | async }}
    </ng-template>

    <ng-template editMode let-element let-dynamicControl="dynamicControl">
      <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
        <mat-select style="width: 100px" [formControl]="dynamicControl" name="reportScheduleFrequencyId">
          <mat-option *ngFor="let r of reportFreqValues | async" [value]="r.reportScheduleFrequencyId">
            {{ r.reportScheduleFrequency }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>

    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let r of reportFreqValues | async" [value]="r.reportScheduleFrequencyId">
            {{ r.reportScheduleFrequency }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

    <!-- sub-tables -->
    <ng-template aimsCommonTableExpandedRow let-element>
      <mat-card>
      <ng-container *ngIf="(isAsRequired(element))">
        <aims-common-table
          [id]="'as-required-table-' + element.position"
          [dataSource]="element.qcReportScheduleAsRequired"
          [header]="asRequiredTableHeader"
          [permissions]="asRequiredTablePermissions"
          [addRowInitialObject]="defaultAsRequiredItem"
          (rowUpdated)="handleAsRequiredRowUpdate($event)"
          (rowAdded)="handleAsRequiredRowAdd($event)"
          (rowDeleted)="handleAsRequiredRowDelete($event)"
          [pageSize]="10">

          <aims-common-table-dynamic-row id="siteId">
            <ng-template viewMode let-element >
              {{ element.siteId | getText:'siteId':'siteCode':siteValues | async }}
            </ng-template>

            <ng-template editMode let-element let-dynamicControl="dynamicControl">
              <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
                <mat-select style="width: 100px" [formControl]="dynamicControl" name="siteId">
                  <mat-option *ngFor="let p of siteValues | async" [value]="p.siteId">
                    {{ p.siteCode }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>

            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let p of siteValues | async" [value]="p.siteId">
                    {{ p.siteCode }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="inspectionSequenceId">
            <ng-template viewMode let-element >
              {{ element.inspectionSequenceId | getText:'inspectionSequenceId':'inspectionSequence':inspectionSequenceValues | async }}
            </ng-template>

            <ng-template editMode let-element let-dynamicControl="dynamicControl">
              <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
                <mat-select style="width: 100px" [formControl]="dynamicControl" name="inspectionSequenceId" required>
                  <mat-option *ngFor="let p of inspectionSequenceValues | async" [value]="p.inspectionSequenceId">
                    {{ p.inspectionSequence }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>

            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let p of inspectionSequenceValues | async" [value]="p.inspectionSequenceId">
                    {{ p.inspectionSequence }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

        </aims-common-table>
      </ng-container>

      <ng-container *ngIf="!(isAsRequired(element))">
        <aims-common-table
          [id]="'scheduled-table-' + element.position"
          [dataSource]="element.qcReportScheduleSchedule"
          [header]="scheduledTableHeader"
          [permissions]="scheduledTablePermissions"
          [addRowInitialObject]="defaultScheduledItem"
          [defaultTableState] = "{ sort:{ active : 'dateDue', direction: 'asc' }}"
          (rowUpdated)="handleScheduledRowUpdate($event)"
          (rowAdded)="handleScheduledRowAdd($event)"
          (rowDeleted)="handleScheduledRowDelete($event)"
          [pageSize]="10">
        </aims-common-table>
      </ng-container>

      </mat-card>
    </ng-template>
</aims-common-table>
